/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, BaseSyntheticEvent} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Datatable} from '../../../../components/Datatable/Datatable'
import type {MetaType} from '../../../../components/Datatable/Datatable'
import {Button} from '../../../../components/Button/Button'
import {CreateContentModal} from '../../../../components/Modals/CreateContentModal/CreateContentModal'
import {EditContentModal} from '../../../../components/Modals/EditContentModal/EditContentModal'
import {useNavigate} from 'react-router-dom'
import {GET, PUT, POST, DELETE} from '../../../../services/api'
import useModals from '../../../../hooks/useModals'
import {Loading} from '../../../../components/Loading/Loading'
import {Input} from '../../../../components/Input/Input'
import Swal from 'sweetalert2'
import {ModalDelete} from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {typeSessionOptions} from './types'
import {i18n} from '../../../../translate/i18n'

type categories = {
  value: string
  select: string
}

const Content: FC = () => {
  const navigate = useNavigate()
  const {showDeleteModal} = useModals()
  const [loading, setLoading] = useState(false)
  const [categories, setCategories] = useState<any[]>([])
  const [services, setServices] = useState<any[]>([])
  const [id, setId] = useState<number | null>(null)
  const [meta, setMeta] = useState<MetaType | undefined>(undefined)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [editData, setEditData] = useState<any | null>(null)
  const [filterSessions, setFilterSessions] = useState<categories[]>([])
  const [sessionHotel, setSessionHotel] = useState<any[]>([])
  const [loadingSession, setLoadingSession] = useState(false)
  const [filterCategoria, setFilterCategoria] = useState<any>({
    label: 'Todos',
    value: 0,
  })
  const [hotelPostPages, setHotelPostPages] = useState<any[]>([])
  const [serviceReservations, setServiceReservations] = useState<any[]>([])

  // Função para filtrar conteúdos
  const filterContent = async () => {
    try {
      setLoadingSession(true)

      const sessionHotelClassificationId =
        filterCategoria.value !== 0 ? filterCategoria.value : undefined

      await getContent(sessionHotelClassificationId)
    } catch (error) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_content.messages.filter_error_title')),
        text: String(i18n.t('hospitality_content.messages.filter_error_text')),
      })
    } finally {
      setLoadingSession(false)
    }
  }

  const getList = async () => {
    try {
      const res = await POST('/session-hotel-classification/filter', {
        deleted: 'not show',
        type: 'default',
      })
      const list = res.data.map((r: any) => ({
        id: r.id,
        name: r.name,
      }))

      setCategories(list)
      const filterSessions = list.map((el: any) => ({value: el.id, select: el.name}))
      filterSessions.push({select: 'Todos', value: 0})
      setFilterSessions(filterSessions)
    } catch (e) {
      console.error('Error fetching classifications', e)
      setCategories([])
    }
  }

  const getFormServices = async () => {
    try {
      const res2 = await GET('/room-service')
      const list2 = Array.isArray(res2) ? res2 : res2.data
      setServices(list2.map((s: any) => ({id: s.id, title: s.title ?? s.name})))
    } catch (e) {
      console.error('Error fetching services', e)
      setServices([])
    }
  }

  const getHotelPostPages = async () => {
    try {
      const res = await GET('/hotel-post-pages')
      setHotelPostPages(res.data || [])
    } catch (e) {
      console.error('Error fetching hotel post pages', e)
      setHotelPostPages([])
    }
  }

  async function getContent(sessionHotelClassificationId?: number) {
    try {
      const filters: any = {}
      if (sessionHotelClassificationId) {
        filters.sessionHotelClassificationId = sessionHotelClassificationId
      }

      let res
      if (Object.keys(filters).length > 0) {
        res = await POST('/session-hotel/filter', filters)
      } else {
        res = await GET('/session-hotel')
      }

      if (!res || !res.data) {
        Swal.fire({
          icon: 'error',
          title: String(i18n.t('hospitality_content.messages.load_error_title')),
          text: String(i18n.t('hospitality_content.messages.load_error_text')),
        })
        return
      }

      const newRes = res.data.map((row: any) => {
        return {
          id: row.id,
          sessionHotelClassificationId: row.sessionHotelClassificationId,
          classificationName:
            row.sessionHotelClassification?.name || i18n.t('hospitality_content.no_category'),
          session:
            row.sessionHotelClassification?.name || i18n.t('hospitality_content.no_category'),
          order: row.order,
          roomServiceId: row.roomServiceId,
          typeSession: row.typeSession,
          typeSessionLabel: findTypeLabel(row.typeSession),
          formTitle: findFormTitle(row, row.typeSession),
          hotelPostPagesId: row.hotelPostPagesId,
          postId: row.postId,
        }
      })

      setSessionHotel(newRes)
      setMeta(res.meta)
    } catch (e) {
      console.log(e)
    }
  }

  const getServiceReservations = async () => {
    try {
      const res = await POST(`/post/filter`, {type: 'hotel_service'})
      const list = Array.isArray(res) ? res : res.data
      setServiceReservations(list.map((s: any) => ({id: s.id, title: s.title})))
    } catch (e) {
      console.error('Error fetching reservations', e)
      setServiceReservations([])
    }
  }

  const findFormTitle = (value: any, typeSession: string) => {
    if (
      typeSession !== 'service_form' &&
      typeSession !== 'page_dynamic' &&
      typeSession !== 'service_reservation'
    )
      return '-'
    if (typeSession === 'service_form') return value.roomService?.title
    if (typeSession === 'page_dynamic') return value.hotelPostPages?.title
    if (typeSession === 'service_reservation') return value.post?.title
    return '-'
  }

  const findTypeLabel = (value: string | null) => {
    if (!value) return ''
    if (value === 'service_form') return i18n.t('hospitality_content.type_labels.service_form')
    if (value === 'page_dynamic') return i18n.t('hospitality_content.type_labels.page_dynamic')
    if (value === 'service_reservation')
      return i18n.t('hospitality_content.type_labels.service_reservation')
    const found = typeSessionOptions.find((t) => t.value === value)
    return found ? found.select : value
  }

  async function getAllData() {
    setLoading(true)

    await Promise.all([
      getContent(),
      getList(),
      getFormServices(),
      getHotelPostPages(),
      getServiceReservations(),
    ])

    setLoading(false)
  }

  const deletePost = async () => {
    if (!id) {
      Swal.fire({
        icon: 'warning',
        title: String(i18n.t('hospitality_content.messages.section_not_found_title')),
        text: String(i18n.t('hospitality_content.messages.section_not_found_text')),
      })
      return
    }

    try {
      setLoading(true)
      const res = await DELETE(`/session-hotel/${id}`)

      setLoading(false)
      if (res.success === true) {
        Swal.fire({
          icon: 'success',
          title: String(i18n.t('hospitality_content.messages.deleted_title')),
          text: String(i18n.t('hospitality_content.messages.deleted_text')),
        }).then(async () => {
          setId(null)
          await getAllData()
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: String(i18n.t('hospitality_content.messages.load_error_title')),
          text: String(i18n.t('hospitality_content.messages.delete_error')),
        })
      }
    } catch (e: any) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_content.actions.delete')),
        text: String((e && e.message) || i18n.t('hospitality_content.messages.delete_error')),
      })
    }
  }

  useEffect(() => {
    getAllData()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t('hospitality_content.page_title')}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t('hospitality_content.page_subtitle')}
                </span>
              </h3>
              <div className='card-toolbar'>
                <Button
                  text={i18n.t('hospitality_content.add_button')}
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => setShowCreateModal(true)}
                  btnClass='mb-5 fw-bolder'
                />
              </div>
            </div>
            <div className='card-body'>
              <div className='d-flex align-items-center justify-content-start'>
                <div className='d-flex w-75 '>
                  <div className=' align-items-end justify-content-start me-5 flex-grow-1'>
                    <span className='align-self-start'>
                      {i18n.t('hospitality_content.filters.sections')}
                    </span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      options={filterSessions}
                      placeholder={i18n.t('hospitality_content.filters.sections')}
                      search={true}
                      value={filterCategoria}
                      change={(value: any) => setFilterCategoria(value)}
                    />
                  </div>
                </div>

                <div
                  className='d-flex align-items-end w-100 justify-content-end h-100'
                  style={{
                    marginTop: '48px',
                  }}
                >
                  <Button
                    text={i18n.t('buttons.filter')}
                    color='primary'
                    iconColor='#FFF'
                    icon='fas fa-filter'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={filterContent}
                    btnClass='mb-0 fw-bolder'
                  />
                </div>
              </div>
              <div>
                {loadingSession ? (
                  <Loading />
                ) : (
                  <Datatable
                    data={sessionHotel}
                    headers={[
                      {
                        key: i18n.t('hospitality_content.table.headers.title'),
                        value: 'session',
                        type: 'default',
                      },
                      {
                        key: i18n.t('hospitality_content.table.headers.order'),
                        value: 'order',
                        type: 'default',
                      },
                      {
                        key: i18n.t('hospitality_content.table.headers.formTitle'),
                        value: 'formTitle',
                        type: 'default',
                      },
                      {
                        key: i18n.t('hospitality_content.table.headers.type'),
                        value: 'typeSessionLabel',
                        type: 'default',
                      },
                      {
                        key: i18n.t('hospitality_content.table.headers.actions'),
                        value: 'acoes',
                        type: '',
                      },
                    ]}
                    options={[
                      {
                        icon: 'fas fa-pen',
                        title: i18n.t('hospitality_content.actions.edit'),
                        action: (item) => {
                          setEditData(item)
                          setShowEditModal(true)
                        },
                      },
                      {
                        icon: 'fas fa-trash',
                        action: (item) => {
                          showDeleteModal(i18n.t('hospitality_content.actions.delete'))
                          setId(item.id)
                        },
                        path: '',
                        title: i18n.t('hospitality_content.actions.delete'),
                      },
                    ]}
                    color='primary'
                  />
                )}
              </div>
            </div>
          </div>
          <ModalDelete confirmAction={() => deletePost()} />
          <CreateContentModal
            show={showCreateModal}
            onClose={() => setShowCreateModal(false)}
            onCreated={async () => {
              setShowCreateModal(false)
              await getAllData()
            }}
            categories={categories}
            formServices={services}
            hotelPostPages={hotelPostPages}
            serviceReservations={serviceReservations}
          />
          <EditContentModal
            show={showEditModal}
            onClose={() => {
              setShowEditModal(false)
              setEditData(null)
            }}
            onUpdated={async () => {
              setShowEditModal(false)
              setEditData(null)
              await getAllData()
            }}
            contentData={editData}
            categories={categories}
            formServices={services}
            hotelPostPages={hotelPostPages}
            serviceReservations={serviceReservations}
          />
        </div>
      )}
    </>
  )
}

export const FeedConteudos: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t('hospitality_content.page_title'),
            path: 'hospitality/feed/content',
            isActive: true,
          },
        ]}
      >
        {i18n.t('hospitality_content.page_title')}
      </PageTitle>
      <Content />
    </>
  )
}
